import React from 'react';
export function KidsMartialArtsFAQHeader() {
  return <h2 className="text-4xl md:text-5xl text-ink text-center mb-16" data-id="element-2117">
      Frequently Asked Questions
    </h2>;
}